class CityAndStateOverlay {
  cityOrState = []
  map = null
  daumInstance = null
  overlayList = []
  clickTargetZoom
  type

  constructor (cityOrState, daumInstance, map, clickTargetZoom) {
    this.cityOrState = cityOrState
    this.daumInstance = daumInstance
    this.map = map
    this.clickTargetZoom = clickTargetZoom


    window.clickCustomOverlay = (lat, lng, zoomLevel) => {
      console.log(this.map)
      console.log(zoomLevel)
      console.log(lat, lng)

      const position = new this.daumInstance.maps.LatLng(lat, lng)
      this.map.setLevel(zoomLevel)
      this.map.setCenter(position)
      this.map.panTo(position)
    }

    this.createOverlay()
  }

  createOverlay () {
    this.cityOrState.map((item, index) => {

      const overlayElem = `<div class="cityAndStateOverlay" onClick="clickCustomOverlay(${this.cityOrState[index].lat}, ${this.cityOrState[index].lng}, ${this.clickTargetZoom})">
        <span>${item.name}</span>
      </div>`

      const customOverlay = new this.daumInstance.maps.CustomOverlay({
        // map: this.map,
        clickable: true,
        content: overlayElem,
        position: new this.daumInstance.maps.LatLng(item.lat, item.lng),
        xAnchor: 0.5,
        yAnchor: 1,
        zIndex: 3
      })

      this.overlayList.push(customOverlay)
    })

    return this.overlayList
  }

  setMap () {
    this.overlayList.map(overlay => {
      overlay.setMap(this.map)
    })
  }

  removeMap () {
    this.overlayList.map(overlay => {
      overlay.setMap(null)
    })
  }
}

export default CityAndStateOverlay
